import { z } from 'zod';
import { GameServiceConfigScheme, OtherSettingsScheme } from '.';

export const SiteSettingsSchemeObject = z
  .object({
    gamesServices: z.array(GameServiceConfigScheme).default([]),
    otherSettings: OtherSettingsScheme
  })
  .passthrough()
  .default({});

/**
 * Scheme for SiteSettings.
 *
 * This scheme is designed for site settings and does not allow any required fields.
 * All fields are either optional or come with default values.
 */
export const SiteSettingsScheme = z.tuple([SiteSettingsSchemeObject]);

export type SiteSettings = z.infer<typeof SiteSettingsScheme>;
